import BaseVitalCard, { VitalCardConfig } from "../../../Common/BaseVitalCard";
import { WellnessScoreStatus } from "../../../Common/types";

export interface BreathingRateCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const config: VitalCardConfig = {
  translationPrefix: "BreathingRate",
  analyticsSource: "Health Score - breathing rate",
  manualEntryRoute: "/home/health-score/breathing-rate-manual-entry",
};

export default function BreathingRateCard(
  props: BreathingRateCardProps
): JSX.Element {
  return <BaseVitalCard {...props} config={config} />;
}
